// extracted by mini-css-extract-plugin
export default {"bar":"TopBar_bar__w7c3a","logo":"TopBar_logo__TBcfs","srOnly":"TopBar_srOnly__dy7tH"};